export default __webpack_public_path__ + "fonts/9948fc3057b02be58d059e8617755dbf.woff2";